import * as z from 'zod';
export const PagingDataSource = z.object({
    pageSize: z.number(),
    load: z.function().args(z.number())
});
export class CollectionBasedPagingDataSource {
    items;
    pageSize;
    constructor(items, pageSize) {
        this.items = items;
        this.pageSize = pageSize;
    }
    load(pageNumber) {
        pageNumber = pageNumber || 1;
        const size = this.pageSize;
        const startIndex = (pageNumber - 1) * size;
        const data = this.items.slice(startIndex, startIndex + size);
        return Promise.resolve({
            pageStart: startIndex,
            pageSize: this.pageSize,
            totalCount: this.items.length,
            count: data.length,
            data
        });
    }
}
export class Pager {
    _items;
    perPage;
    history;
    currentPage;
    items;
    startIndex;
    constructor(items, pageSize) {
        this._items = items;
        this.perPage = pageSize;
        this.currentPage = 1;
        this.history = [];
        this.setCurrentPage(this.currentPage);
    }
    get totalRows() {
        return this._items.length;
    }
    setCurrentPage(page) {
        if (!this.history.length ||
            this.history[this.history.length - 1] != this.currentPage) {
            this.history.push(this.currentPage);
        }
        const minPage = 1;
        const maxPage = Math.floor(this.totalRows / this.perPage) + 1;
        page = Math.min(Math.max(minPage, page), maxPage);
        const startIndex = (page - 1) * this.perPage;
        this.items = this._items.slice(startIndex, startIndex + this.perPage);
        this.currentPage = page;
        this.startIndex = startIndex;
    }
    setItems(items) {
        this._items = items;
        this.setCurrentPage(this.currentPage);
    }
}
//# sourceMappingURL=pagination.js.map